import { Switch as cSwitch } from '@coreui/vue';

//restful api
import { system as wmds } from '@/service/api/wmds';

export default {
  components: {
    cSwitch,
  },
  data : () => {
    return {
      confirm: false,
      add: false,
      lock: true,
      model : { group: {} },
    }
  },
  methods: {
    regex_valid: (c, f = '') => {
      if(!c) { return false }
      try { new RegExp(c, f); return true } catch(e) { return false }
    },
    cancel() { this.lock = true; this.$router.replace({ name: 'wmds_spattern', params: { id: this.model.id }}) },
    edit() { this.$router.replace({ name: 'wmds_spattern', params: { id: this.model.id, tag: 'edit' }}) },
    async remove() {
      try{
        let rs = await wmds.deleteSys({ id :this.model.id })
        if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            this.$toastr.e('delete', "failed")
          }
          this.list(); this.$emit("refresh");
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    list() { this.$router.push({ name: 'wmds_spattern'}); this.$emit('refresh'); },
    async save() {
      if(!(this.model.code || '').trim()) { return this.$toastr.e('Pattern is Require'); }
      if(!this.regex_valid(this.model.code)) { return this.$toastr.e("No vaild expression"); }

      try {
        let check_id = '';
        check_id = this.model.id ? `${await wmds.updateSys(this.model)}` : `${await wmds.insertSys(this.model)}`;

        let rs = check_id;

        if(!rs.error) {
          this.$toastr.s('Saved.', this.$route.name ); this.cancel();
        } else {
          this.$toastr.s('Save', "failed"); this.list();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      console.log('pattern.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = { is_alive: true, level: 'W', type: 'U' }; return; }
      try{
        this.add = false;
        this.lock = (tag !== 'edit');
        let rs = await wmds.detailSys({ id : id })
        this.model = Object.assign({ group: {} }, this.model, rs.body)
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('pattern.detail.vue', 'created'); },
  destroyed() { console.log('pattern.detail.vue', 'destroyed'); },
  mounted() {
    console.log('pattern.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}